import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annual-report',
  templateUrl: './annual-report.component.html',
  styleUrls: ['./annual-report.component.scss']
})
export class AnnualReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
